/**
 * @generated SignedSource<<6ffbe4ae345df4fbec93aaa7ac52e6f4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganizationAppIdResolverQuery$variables = {
  appSlug: string;
  organizationSlug: string;
};
export type OrganizationAppIdResolverQuery$data = {
  readonly viewer: {
    readonly app: {
      readonly id: string;
    } | null | undefined;
    readonly me: {
      readonly id: string;
    } | null | undefined;
  };
};
export type OrganizationAppIdResolverQuery = {
  response: OrganizationAppIdResolverQuery$data;
  variables: OrganizationAppIdResolverQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationSlug"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": (v2/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "appSlug",
            "variableName": "appSlug"
          },
          {
            "kind": "Variable",
            "name": "organizationSlug",
            "variableName": "organizationSlug"
          }
        ],
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": (v2/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationAppIdResolverQuery",
    "selections": (v3/*:: as any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "OrganizationAppIdResolverQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "d8ca206b25baad3d2b39def828ce79bd",
    "id": null,
    "metadata": {},
    "name": "OrganizationAppIdResolverQuery",
    "operationKind": "query",
    "text": "query OrganizationAppIdResolverQuery(\n  $organizationSlug: String!\n  $appSlug: String!\n) {\n  viewer {\n    me {\n      id\n    }\n    app(organizationSlug: $organizationSlug, appSlug: $appSlug) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "86baa5aa6f0901c59d87071c3e182b67";

export default node;
